// ── Aviso de manutenção do login (fonte única: desktop + mobile leem daqui) ──────
//
// Quem liga e desliga é o BANCO, sem deploy:
//     UPDATE crm_manutencao SET em_manutencao = true;   -- ou false
// (tabela de linha única no banco principal, lida pelo endpoint GET /api/manutencao)
//
// Duas saídas de emergência continuam existindo, para quando o banco/API estiver fora
// — que é justamente quando o aviso mais faz falta:
//   1. `FORCAR_MANUTENCAO = true` aqui + deploy do front;
//   2. `?manutencao=1` na URL do login (pré-visualização, vale só para quem abrir assim).
import { useEffect, useState } from "react";
import { API_URL } from "../../../environment";

// Força o aviso independente do banco. Deixe `false` no dia a dia.
export const FORCAR_MANUTENCAO = false;

export const MSG_MANUTENCAO =
  "Sistema em manutenção no momento. Algumas funções podem ficar instáveis temporariamente — agradecemos a compreensão.";

/** Aviso forçado por código ou por `?manutencao=1` — não depende do banco. */
export const emManutencao = (): boolean =>
  FORCAR_MANUTENCAO ||
  (typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("manutencao"));

/**
 * Estado do aviso: o forçado vale na hora; senão pergunta ao backend.
 *
 * 🔴 Erro de rede/banco mantém o aviso DESLIGADO de propósito: sem conseguir ler a
 * flag, inventar um aviso de manutenção é pior do que não mostrar nada. E o fetch
 * nunca bloqueia o render — a tela de login aparece na hora, o aviso entra depois.
 */
export const useManutencao = (): boolean => {
  const forcado = emManutencao();
  const [ligado, setLigado] = useState<boolean>(forcado);

  useEffect(() => {
    if (forcado) return;            // já está decidido, não precisa perguntar
    let vivo = true;                // evita setState depois de desmontar
    fetch(`${API_URL}/manutencao`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (vivo && d && typeof d.em_manutencao === "boolean") setLigado(d.em_manutencao);
      })
      .catch(() => {
        /* API fora: segue desligado (ver comentário acima) */
      });
    return () => {
      vivo = false;
    };
  }, [forcado]);

  return ligado;
};
